// extracted by mini-css-extract-plugin
export var aircallIframe = "_kj-3";
export var fabContainer = "_kj-5";
export var fabRinging = "_kj-6";
export var loadingOverlay = "_kj-4";
export var pulse = "_kj-7";
export var widgetContent = "_kj-2";
export var widgetPanel = "_kj-0";
export var widgetPanelExpanded = "_kj-1";